import { FC } from "react";

import { MuiButton } from "@ryde/controls";

import { ApiKeyTokenDialogStyled } from "./api-key-token-dialog.styled";
import { useApiKeyTokenCopy } from "./use-api-key-token-copy";

interface IApiKeyTokenDialogProps {
  token: string;
}

export const ApiKeyTokenDialog: FC<IApiKeyTokenDialogProps> = ({ token }) => {
  const { t, onCopyClick } = useApiKeyTokenCopy(token);

  return (
    <ApiKeyTokenDialogStyled>
      <code
        className="api-key-token-dialog__token"
        aria-label={t("apiKey.tokenDialog.tokenLabel")}
      >
        {token}
      </code>
      <MuiButton onClick={onCopyClick}>{t("apiKey.actions.copy")}</MuiButton>
      <p className="api-key-token-dialog__usage">
        {t("apiKey.tokenDialog.usage")}
      </p>
    </ApiKeyTokenDialogStyled>
  );
};
